import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from '@/shared/components/Modal';
import { Input } from '@/shared/components/Input';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useUpdateMyProfile } from '../hooks/useStudentProfile';
export function EditProfileModal({ open, onClose, initial }) {
    const [serverError, setServerError] = useState('');
    const update = useUpdateMyProfile();
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: { phone: initial.phone ?? '', address: initial.address ?? '' },
    });
    function onSubmit(values) {
        setServerError('');
        update.mutate({
            ...(values.phone.trim() ? { phone: values.phone.trim() } : {}),
            ...(values.address.trim() ? { address: values.address.trim() } : {}),
        }, {
            onSuccess: () => onClose(),
            onError: (err) => setServerError(err instanceof ApiError ? err.message : 'No se pudieron guardar los cambios.'),
        });
    }
    return (_jsx(Modal, { open: open, onClose: onClose, title: "Editar mis datos", size: "sm", children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Input, { label: "Tel\u00E9fono", error: errors.phone?.message, ...register('phone', {
                        pattern: { value: /^[6789]\d{8}$/, message: 'Teléfono inválido' },
                    }) }), _jsx(Input, { label: "Direcci\u00F3n", ...register('address', { maxLength: { value: 300, message: 'Máximo 300 caracteres' } }), error: errors.address?.message }), serverError && _jsx("p", { role: "alert", className: "text-sm text-red-600 dark:text-red-400", children: serverError }), _jsxs("div", { className: "flex justify-end gap-3", children: [_jsx(Button, { type: "button", variant: "secondary", onClick: onClose, children: "Cancelar" }), _jsx(Button, { type: "submit", loading: update.isPending, children: "Guardar" })] })] }) }));
}
//# sourceMappingURL=EditProfileModal.js.map